import cn from "classnames"
import is from "is_js"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { getKeys, SpinnerContainer } from "swiipe.portal.shared"
import "./UploadedFilesOverview.scss"

interface IUploadedFilesOverviewProps {
    files?: FileList
    className?: string
    onRemoveFile?: (fileIndex: number) => void
    showUnsavedWarning?: boolean
}

interface IUploadedFile {
    name: string
    status?: "saved" | "submitted"
    id?: string
    canRemove?: boolean
}

interface IUploadedFilesOverviewTextProps {
    files?: IUploadedFile[]
    wrongFilesOverview?: boolean
    className?: string
    onRemoveFile?: (file: IUploadedFile) => Promise<void>
}

const UploadedFilesOverview = ({ files, className, onRemoveFile, showUnsavedWarning }: IUploadedFilesOverviewProps) => {
    //Create file list is not supported by IE and Safari
    //So we can't remove files one by one and should show only
    //one delete button to not confuse users
    const singleDeleteButton = is.safari() || is.ie()
    const { t } = useTranslation()

    return (
        <div className={cn("swiipe-files-list", className)}>
            {files &&
                getKeys(files).map((key) => {
                    return (
                        <div className="file-option" key={key}>
                            <span className="file">{files[key as any].name}</span>
                            {showUnsavedWarning && (
                                <span className={cn("swiipe-files-list__status", `swiipe-files-list__status--unsaved`)}>
                                    {t("fileStatus.unsaved")}
                                </span>
                            )}
                            {onRemoveFile && (!singleDeleteButton || key === "0") && (
                                <div
                                    className="delete-file-btn"
                                    onClick={() => {
                                        onRemoveFile(parseInt(key))
                                    }}
                                >
                                    ×
                                </div>
                            )}
                        </div>
                    )
                })}
        </div>
    )
}

export const UploadedFilesOverviewText = ({
    files,

    wrongFilesOverview,
    className,
    onRemoveFile,
}: IUploadedFilesOverviewTextProps) => {
    const [isRemovingIndexes, setIsRemovingIndexes] = useState<number[]>([])
    const { t } = useTranslation()
    return (
        <div className={cn("swiipe-files-list", wrongFilesOverview ? "mb-smaller" : "", className)}>
            {files &&
                files.map((file, i) => {
                    return (
                        <div className={cn("file-option", wrongFilesOverview ? "red-color" : "")} key={i}>
                            <SpinnerContainer showSpinner={isRemovingIndexes.includes(i)}>
                                <span className="file">{file.name}</span>
                                {file.status && (
                                    <span
                                        className={cn("swiipe-files-list__status", `swiipe-files-list__status--${file.status}`)}
                                    >
                                        {file.status === "saved" ? t("fileStatus.saved") : t("fileStatus.submitted")}
                                    </span>
                                )}
                                {onRemoveFile && file.canRemove && (
                                    <div
                                        className="delete-file-btn"
                                        onClick={async () => {
                                            setIsRemovingIndexes([...isRemovingIndexes, i])
                                            await onRemoveFile(file)
                                            setIsRemovingIndexes(isRemovingIndexes.filter((ri) => ri !== i))
                                        }}
                                    >
                                        ×
                                    </div>
                                )}
                            </SpinnerContainer>
                        </div>
                    )
                })}
        </div>
    )
}

export default UploadedFilesOverview
